import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import Header from '../components/Header';
import Footer from '../components/Footer';

const HowWeWork = () => {
  const navigate = useNavigate();
  const steps = [
    {
      number: '01',
      title: 'Buyer Verification',
      description: 'We identify and verify genuine international buyers looking for your products.'
    },
    {
      number: '02',
      title: 'Contract Finalisation',
      description: 'We negotiate and finalize export contracts with competitive terms.'
    },
    {
      number: '03',
      title: 'Exporter Allocation',
      description: 'We match verified exporters with buyer requirements based on capacity and quality.'
    },
    {
      number: '04',
      title: 'Bank-Controlled Payment',
      description: 'All payments flow through secure banking channels for maximum safety.'
    },
    {
      number: '05',
      title: 'Shipment & Delivery',
      description: 'We manage documentation, logistics, and ensure timely delivery to buyers.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Banner */}
      <section className="bg-[#0B2C4D] text-white py-20">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold mb-6">How We Work</h1>
          <p className="text-xl max-w-2xl mx-auto">
            Our streamlined process makes exports safe, bankable, and scalable.
          </p>
        </div>
      </section>

      {/* Process Flow */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="flex items-start gap-6 mb-8">
                  {/* Step Number */}
                  <div className="flex-shrink-0">
                    <div className="w-20 h-20 bg-[#0B2C4D] rounded-full flex items-center justify-center border-4 border-[#C9A24D]">
                      <span className="text-2xl font-bold text-[#C9A24D]">{step.number}</span>
                    </div>
                  </div>
                  
                  {/* Step Content */}
                  <div className="flex-1 bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-[#C9A24D]">
                    <h3 className="text-2xl font-bold text-[#0B2C4D] mb-3">{step.title}</h3>
                    <p className="text-lg text-gray-700">{step.description}</p>
                  </div>
                </div>
                
                {/* Arrow between steps */}
                {index < steps.length - 1 && (
                  <div className="flex justify-center mb-8">
                    <ArrowRight className="w-8 h-8 text-[#C9A24D] rotate-90" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <CheckCircle className="w-16 h-16 text-[#C9A24D] mx-auto mb-6" />
            <h2 className="text-3xl font-bold text-[#0B2C4D] mb-6">
              This Process Makes Exports:
            </h2>
            <div className="grid md:grid-cols-3 gap-6 mb-8">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <p className="text-xl font-semibold text-[#0B2C4D]">Safe</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md">
                <p className="text-xl font-semibold text-[#0B2C4D]">Bankable</p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md">
                <p className="text-xl font-semibold text-[#0B2C4D]">Scalable</p>
              </div>
            </div>
            <Button 
              size="lg"
              className="bg-[#C9A24D] hover:bg-[#b8923e] text-[#0B2C4D] font-semibold text-lg px-10 py-6"
              onClick={() => navigate('/contact')}
            >
              Enquiry Now
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HowWeWork;
